import { styled, Divider } from '@/theme/index';

export const ModalWrapper = styled('div')`
  cursor: pointer;
`;

export const SectionDivider = () => (
  <Divider
    sx={(theme) => ({
      marginBlock: { xs: 2, sm: 2.5 },
      borderColor: theme.palette.grey[300],
    })}
  />
);
